/**
 * @generated SignedSource<<42ec2058f61b69e6cf1c9a1f70dd62cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignedActorBadge_actor$data = {
  readonly __typename: "ConnectActor";
  readonly employee: {
    readonly __typename: "Employee";
  } | null;
  readonly " $fragmentType": "SignedActorBadge_actor";
} | {
  readonly __typename: "GroupActor";
  readonly employee: {
    readonly __typename: "Employee";
  } | null;
  readonly user: {
    readonly __typename: "User";
  } | null;
  readonly " $fragmentType": "SignedActorBadge_actor";
} | {
  readonly __typename: "UserActor";
  readonly storeUser: {
    readonly user: {
      readonly orgDescription: {
        readonly orgIconUri: string | null;
      } | null;
    };
  } | null;
  readonly " $fragmentType": "SignedActorBadge_actor";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "SignedActorBadge_actor";
};
export type SignedActorBadge_actor$key = {
  readonly " $data"?: SignedActorBadge_actor$data;
  readonly " $fragmentSpreads": FragmentRefs<"SignedActorBadge_actor">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Employee",
  "kind": "LinkedField",
  "name": "employee",
  "plural": false,
  "selections": (v1/*: any*/),
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SignedActorBadge_actor",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "StoreUser",
          "kind": "LinkedField",
          "name": "storeUser",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "OrgDescription",
                  "kind": "LinkedField",
                  "name": "orgDescription",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "orgIconUri",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "type": "UserActor",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v2/*: any*/),
        (v0/*: any*/)
      ],
      "type": "ConnectActor",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "type": "GroupActor",
      "abstractKey": null
    }
  ],
  "type": "Actor",
  "abstractKey": "__isActor"
};
})();

(node as any).hash = "931dbae24f5f002953276b40e5af2bda";

export default node;
